<!-- @format -->

<div class="cdialog" style="max-height: 80vh; max-width: 80vw;">
  <div class="dialogHeader">
    <div mat-dialog-title>{{_common.poster_display}}</div>

    <div class="spacer"></div>
    <div (click)="cancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>

  <mat-dialog-content class="max-height">
    <div class="max-scroll dialogBody">
      <form [formGroup]="form" *ngIf="object">
        <div>{{_common.file_name}}: {{object.filename}}</div>
        <div>
          <img [src]="contentImage(object)" />
        </div>

      </form>
      <button class="app-btn btn-outline w-full mt-6" (click)="remove()" *ngIf="objectId">
        <fa-icon icon="trash" style="margin-right: 5px"></fa-icon
        >{{_common.delete_file}}
      </button>
    </div>

  </mat-dialog-content>
  <!-- <div class="dialogBar">
    <button class="app-btn btn-outline" (click)="remove()" *ngIf="objectId">
      <fa-icon icon="trash" style="margin-right: 5px"></fa-icon
      >{{_common.delete}}
    </button>

    <div class="spacer"></div>

    <button class="app-btn" (click)="save()" color="primary">
      {{_common.save}}
    </button>
  </div> -->
</div>
